import { observer } from 'mobx-react-lite';
import { ModalOption } from '../../../stores/modalStore';
import { Modal } from './Modal';

const AlertModal = observer(({ modalId, option }: { modalId: string; option: ModalOption }) => {
    return (
        <Modal.Dialog modalId={modalId}>
            <Modal.BodyScroll>
                <p>{option.alert?.message}</p>
            </Modal.BodyScroll>
            <Modal.ActionButton
                modalId={modalId}
                confirmStyle="default"
                isShowCancel={false}
                confirmText={option.alert?.confirmText}
            />
        </Modal.Dialog>
    );
});

export default AlertModal;
